export default () => ({
  errorsList: ["Error en la linea 2", "Error en la linea 34"],
  showErrorsModal: true,
  audios: [],
  grabaciones: [],
  grabacionesTotal: 0,
  grabacionesIndicators: {
    total_grabaciones: 0,
    duracion_total_segundos: 0,
    duracion_total: "00:00:00",
    almacenamiento_usado_bytes: 0,
    almacenamiento_usado: "0 MB",
    porcentaje_transcripcion: 0,
  },
  meetings: {},
  zohoCrm: {
    isZohoActivated: false,
    form: null,
  },
  zohoDesk: {
    isZohoActivated: true,
    form: null,
    zoho_client_id: "",
    zoho_client_secret: "",
  },
  zohoUser: {
    form: null,
  },
  labels: null,
  eventTypes: null
});
